import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'via-export-infographics',
  templateUrl: './export-infographics.component.html',
  styleUrls: ['./export-infographics.component.scss']
})
export class ExportInfographicsComponent {
  @ViewChildren('animate')
  public elementsToAnimate: QueryList<ElementRef>;
}
